/**
 * Módulo: Section Conteúdos
 * Swiper no desktop (≥768px); itens empilhados no mobile.
 * Usa matchMedia + destroy(true, true) para alternar entre os modos.
 */

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initSectionConteudos() {
  document.querySelectorAll('.section-conteudos__swiper').forEach(el => {
    const wrapper = el.closest('.section-conteudos');
    if (!wrapper) return;

    const prevEl = wrapper.querySelector('.section-conteudos__btn--prev');
    const nextEl = wrapper.querySelector('.section-conteudos__btn--next');

    const mq = window.matchMedia('(min-width: 768px)');

    function initSwiper() {
      if (el.swiper) return;

      new Swiper(el, {
        modules: [Navigation],
        slidesPerView: 1.15,
        spaceBetween: 20,
        loop: false,
        navigation: {
          prevEl,
          nextEl,
        },
        a11y: {
          prevSlideMessage: 'Slide anterior',
          nextSlideMessage: 'Próximo slide',
        },
      });
    }

    function destroySwiper() {
      if (el.swiper) el.swiper.destroy(true, true);
    }

    mq.addEventListener('change', e => {
      if (e.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    });

    if (mq.matches) {
      initSwiper();
    }
  });
}
